import muster from '@dbk-legacy/muster';
import { variable } from '@dbk-legacy/muster/helpers';
import { ROUTES } from '../constants';

export default () => {
  return muster()

    .path('pis.signConsent', {
      call: async ({ req }, { get, set, call }) => {
        await set('pis.isPisSuccess', true);
      }
    })

    .path('pis.resetPaymentStatus', {
      call: async ({ req }, { get, set, call }) => {
        await set('pis.isPaymentOtpVerified', null);
        await set('pis.isPaymentExecute', null);
      }
    })
    .path('pis.executePayment', {
      call: async ({ req }, { get, set, call }) => {
       
        if(req.args[0] === "confirm"){
          await set('vascoauthentication.vascoVisible', true);
          await set('pis.isPaymentExecute', true);
        }
        if(req.args[0] === "reject"){
          await set('pis.isPaymentExecute', false);
        }
      }
    })

    .path('otpVerificationSuccess', {
      call: async ({ req }, { get, set, call }) => {
        call('ui.history.push', { pathname: ROUTES.PAYMENT.PSD2_PIS });
      }
    })

    .path('pis.aisSuccess', variable(false))
    .path('pis.isPaymentExecute', variable(null))
    .path('pis.isPaymentOtpVerified', variable(null))
    .path('pis.isPisSuccess', variable(false))  
}